import { render, staticRenderFns } from "./edit.badges.page.vue?vue&type=template&id=65859914&"
import script from "./edit.badges.page.vue?vue&type=script&lang=js&"
export * from "./edit.badges.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports